import template from './onboarding.html';
import controller from './onboarding.controller';

let onboardingComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default onboardingComponent;



// WEBPACK FOOTER //
// ./app/components/onboarding/onboarding.component.js